import React, { useState, useEffect, useCallback } from "react";
import "./organization-access-code-delete.scss";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useMatch } from "react-router-dom";
import {
  selectAccessListNotifications,
  selectCurrentList,
  selectCurrentAccessCode,
  selectCurrentAccessCodeMember,
  getOrganizationAccessListCode,
  getOrganizationAccessListCodeMember,
  clearNotifications,
  setSelectedCode,
  deleteOrganizationAccessCode,
  getOrganizationAccessList,
} from "../../reducers/accessSlice";

import { getRemoveTitle, removeItemForm } from "../../forms/DeleteForm";
import OrganizationAccessCodeItem from "./organization-access-code-item";

const OrganizationAccessCodeDelete = () => {
  const [isValid, setIsValid] = useState(true);
  const [code, setCode] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const matchEdit = useMatch("/:id/access/:accessListID/code/:accessCodeID/*");

  const orgNotifications = useSelector(selectAccessListNotifications);
  const currentList = useSelector(selectCurrentList);
  const currentCode = useSelector(selectCurrentAccessCode);
  const currentCodeMember = useSelector(selectCurrentAccessCodeMember);

  const backToList = () => {
    navigate(`/${matchEdit.params.id}/access/${matchEdit.params.accessListID}`);
  };

  const loadCode = useCallback(() => {
    if (matchEdit?.params?.accessCodeID !== "add") {
      dispatch(getOrganizationAccessListCode(matchEdit?.params?.accessCodeID));
      dispatch(
        getOrganizationAccessListCodeMember(matchEdit?.params?.accessCodeID)
      );
      dispatch(getOrganizationAccessList(matchEdit?.params?.accessListID));
    } else {
      setCode({});
    }
  }, [dispatch, matchEdit?.params]);

  useEffect(() => {
    loadCode();
    return () => {
      dispatch(setSelectedCode({}));
    };
  }, [loadCode, dispatch]);

  useEffect(() => {
    const { id, accessCodeID } = matchEdit?.params;
    if (currentCode?.id) {
      if (currentCode?.id !== accessCodeID) {
        navigate(`/${id}/access/${currentList.id}/code/${currentCode.id}`);
      } else {
        let accessCode = { ...currentCode };
        if (accessCode?.maxUseQuantity === null) {
          accessCode.codeUsage = { id: 1, label: "Unlimited Use", value: 1 };
        } else {
          accessCode.codeUsage = { id: 2, label: "Limited Use", value: 2 };
        }
        setCode(accessCode);
      }
    } else {
      setCode({});
    }
  }, [currentCode, matchEdit?.params, currentList, navigate]);

  useEffect(() => {
    if (currentCodeMember?.id) {
      setCode({ ...currentCode, accessMember: currentCodeMember });
    }
  }, [currentCodeMember, currentCode, matchEdit?.params, navigate]);

  useEffect(() => {
    if (
      orgNotifications.length > 0 &&
      orgNotifications[0].state === "success"
    ) {
      navigate(
        `/${matchEdit.params.id}/access/${matchEdit.params.accessListID}`
      );
    }
  }, [orgNotifications, dispatch, navigate, matchEdit.params]);

  const removeMember = () => {
    setIsValid(false);
    if (matchEdit.params.id) {
      dispatch(deleteOrganizationAccessCode(matchEdit?.params?.accessCodeID));
    }
  };

  const leftNavigation = () => {
    navigate(-1);
  };

  const getActions = () => {
    let actions = [
      {
        name: "Delete",
        action: removeMember,
        isDisabled: !isValid,
        type: "red",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const getNavigation = () => {
    return {
      title: "Delete Code",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const hasNotifications = (notifications) => {
    return notifications && notifications.length > 0;
  };

  const getBanner = () => {
    const slideOutNotifications = orgNotifications;
    if (hasNotifications(slideOutNotifications)) {
      return {
        notifications: slideOutNotifications.map((n) => ({
          ...n,
          pageActions: getBannerActions(),
        })),
        timeoutAction: timeoutAction,
        timeout: 10000,
      };
    }
  };

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const getBannerActions = () => {
    return [
      {
        id: 1,
        title: "Back to access list",
        size: "secondary",
        actionClick: backToList,
      },
    ];
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle={getRemoveTitle("Delete Code")}
        formSections={removeItemForm(
          code?.identifier,
          <OrganizationAccessCodeItem {...code} />,
          "delete",
          `Are you sure you want to delete ${code?.identifier} from ${currentList?.description}? This cannot be undone.`
        )}
      />
    );
  };
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };
  return (
    <organization-access-code-delete>
      <GSSidePanelPage
        header={getNavigation()}
        banner={getBanner()}
        content={getContent()}
        drawer={getDrawer()}
      />
    </organization-access-code-delete>
  );
};

export default OrganizationAccessCodeDelete;
